import React, { useState, useEffect, useMemo } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Row } from "react-bootstrap";
//import {  toast } from 'react-toastify';
import _ from "lodash";
import ApiAmusementPlace from "../../../core/api/api.amusementPlace";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { Link } from "react-router-dom";
import Select from "react-select";
import ApiAmusementService from "../../../core/api/api.amusementService";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiRegion from "../../../core/api/api.region";

const AmusementPlace = () => {
  const [listData, setListData] = useState([{}]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors }, getValues, setValue, watch };
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const [selectPlaceCityList, setselectPlaceCityList] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const responsegetAllCity = await ApiRegion.getAllCity();
        setAllAmusementCityList(responsegetAllCity);
        const data = await ApiAmusementPlace.getAll({
          pageSize: getValues("pageSize"),
          pageNumber: getValues("pageNumber"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => { };
  }, []);

  const onSubmit = async (data) => {
    data.placeCityListId = data.placeCityListId?.map((item) => item.value);

    const apiData = await ApiAmusementPlace.getAll({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: {
        globalSearch: data.globalSearch,
        cityIdList: data.placeCityListId,
      },
    });
    setListData(apiData);
  };

  const handleChangeMultiCity = (event) => {
    setValue("placeCityListId", event);
  };
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مکان تفریحات</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست مکان های ثبت شده</span>
          </h3>
          <div className="card-toolbar">
            <Link to="/createOrEditPlace" className="btn btn-primary">
              <AddCircle className="mr-1" />
              ایجاد مکان جدید{" "}
            </Link>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <Row className="border-top border-bottom py-3 mb-3">
                <Col sm className="tb-reponsive  px-2">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        style={{ borderColor: "#cdcdcd" }}
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                </Col>
                <Col sm="5" className="tb-reponsive  px-2">
                  <Controller
                    name="placeCityListId"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        inputId="react-select-with-search"
                        className="w-20 "
                        variant="outlined"
                        size="small"
                        placeholder="انتخاب شهر"
                        TextFieldProps={{
                          label: "Countries",
                          InputLabelProps: {
                            htmlFor: "react-select-multiple",
                            shrink: true,
                          },
                        }}
                        options={allAmusementCityList?.map((item) => ({
                          value: item.id,
                          label: item.id + "-" + item.name,
                        }))}
                        closeMenuOnSelect={false}
                        isMulti
                        value={value || ""}
                        onChange={handleChangeMultiCity}
                      />
                    )}
                  />
                </Col>

                <Col sm="auto" className="px-0">
                  <Button variant="secondary" type="submit" disabled={isSubmitting} style={{ minHeight: "2.9rem" }}>
                    <SearchIcon />
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid data={listData} />
                </Col>
              </Row>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default AmusementPlace;
